import React, { useState } from "react";

import styles from "../assets/styles/kpi-list.module.scss";

import { FormattedMessage } from "react-intl";
import { Typography } from "@mui/material";

export default function KPIList({
  title,
  stores,
  setSelectedStore,
  selectedStore,
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const toggle = (index) => {
    setSelectedIndex(index);
  };

  if (stores.length > 0) {
    return (
      <React.Fragment>
        <div className={styles["kpi-list"]}>
          {/* create an initial cell with title of the list in it */}
          <div
            style={{
              background: "var(--container-light)",
              height: "45px",
              border: " 1px solid var(--border)",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              component="span"
              style={{ fontSize: "14px", marginLeft: "10px", fontWeight: 500 }}
            >
              <FormattedMessage id={title} />
            </Typography>
          </div>

          {/* map all stores */}
          {stores.map((store, index) => {
            return (
              <div
                style={{
                  background: "var(--container-light)",
                  height: "45px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid var(--border)",
                  cursor: "pointer",
                  padding: "8px",
                  overflow: "hidden",
                }}
                key={`connector-${index}`}
                onClick={() => {
                  toggle(index);
                  setSelectedStore(store);
                }}
              >
                <img
                  alt="Store logo"
                  src={store.logo}
                  style={{
                    width: "auto",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  className={
                    selectedIndex === index
                      ? styles["img-selected"]
                      : styles["img-default"]
                  }
                />
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  } else {
    return "";
  }
}
